// src/components/FieldRenderer.js

import React from 'react';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './FieldRenderer.css'; // Import the CSS file for styling

function FieldRenderer({
    field,
    label,
    type,
    value,
    required,
    error,
    onChange,
    options, // Accept options for dropdown fields
}) {
    const handleChange = (value) => {
        onChange(field, value);
    };

    switch (type) {
        case 'text':
            return (
                <div className="form-group">
                    <label>
                        {label}
                        {required && ' *'}
                    </label>
                    <textarea
                        value={value || ''}
                        onChange={(e) => handleChange(e.target.value)}
                        rows="3"
                    />
                    {error && <p className="error-message">{error}</p>}
                </div>
            );
        case 'date':
            return (
                <div className="form-group">
                    <label>
                        {label}
                        {required && ' *'}
                    </label>
                    <DatePicker
                        selected={value}
                        onChange={(date) => handleChange(date)}
                        dateFormat="yyyy-MM-dd"
                    />
                    {error && <p className="error-message">{error}</p>}
                </div>
            );
        case 'wysiwyg':
            return (
                <div className="form-group">
                    <label>
                        {label}
                        {required && ' *'}
                    </label>
                    <ReactQuill
                        value={value || ''}
                        onChange={(value) => handleChange(value)}
                        modules={{
                            toolbar: [
                                [{ header: [1, 2, 3, 4, false] }],
                                ['bold', 'italic', 'underline'],
                                ['link'],
                            ],
                        }}
                        formats={['header', 'bold', 'italic', 'underline', 'link']}
                    />
                    {error && <p className="error-message">{error}</p>}
                </div>
            );
        
        case 'radio':
            return (
                <div className="form-group">
                    <label>
                        {label}
                        {required && ' *'}
                    </label>
                    <div>
                        <label>
                            <input
                                type="radio"
                                name={field}
                                value="Active"
                                checked={value === 'Active'}
                                onChange={() => handleChange('Active')}
                            />
                            發佈
                        </label>
                        <label>
                            <input
                                type="radio"
                                name={field}
                                value="Inactive"
                                checked={value === 'Inactive'}
                                onChange={() => handleChange('Inactive')}
                            />
                            不發佈
                        </label>
                    </div>
                    {error && <p className="error-message">{error}</p>}
                </div>
            );
            case 'dropdown':
                return (
                    <div className="form-group">
                        <label>
                            {label}
                            {required && ' *'}
                        </label>
                        <select
                            value={value || ''}
                            onChange={(e) => handleChange(e.target.value)}
                        >
                            <option value="" disabled>
                                -- 請選擇 --
                            </option>
                            {options &&
                                options.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                        </select>
                        {error && <p className="error-message">{error}</p>}
                    </div>
                );
            default:
                return (
                    <div className="form-group">
                        <label>
                            {label}
                            {required && ' *'}
                        </label>
                        <input
                            type="text"
                            value={value || ''}
                            onChange={(e) => handleChange(e.target.value)}
                        />
                        {error && <p className="error-message">{error}</p>}
                    </div>
                );
    }
}

export default FieldRenderer;
